import { createTheme } from "@mantine/core";

const COLOR_ORANGE = [
  "#FFF6F2",
  "#FFE5D7",
  "#FFD4BC",
  "#FFAD84",
  "#FB8951",
  "#E96929",
  "#D24E0D",
  "#B43C00",
  "#8F3000",
  "#632100",
] as const;

const COLOR_BLUE = [
  "#F2FCFF",
  "#D7F7FF",
  "#BCF2FF",
  "#84E2FF",
  "#51D0FB",
  "#29B9E9",
  "#0DA0D2",
  "#0087B4",
  "#006B8F",
  "#004A63",
] as const;

const COLOR_PRIMARY = [
  "#F1F7FE",
  "#E3EDFB",
  "#C1DBF6",
  "#8ABDEF",
  "#4B9BE5",
  "#247ED3",
  "#1662B3",
  "#124B8C",
  "#144378",
  "#144378",
] as const;

const COLOR_NEUTRAL = [
  "#FAFAFA",
  "#F8F8F8",
  "#F4F4F4",
  "#E9E9E9",
  "#D2D2D2",
  "#BCBCBC",
  "#979797",
  "#727272",
  "#565656",
  "#393939",
] as const;

const COLOR_RED = [
  "#ffe8ef",
  "#ffcfda",
  "#fe9db1",
  "#fc5275",
  "#fb3b61",
  "#fa1f4a",
  "#fb0d3e",
  "#e00030",
  "#c8002a",
  "#b00022",
] as const;

const COLOR_INFORMATIVE = [
  "#e4f4ff",
  "#cee4ff",
  "#9ec6fd",
  "#6ba6f9",
  "#5598f6",
  "#247af3",
  "#0e72f4",
  "#0060da",
  "#0055c4",
  "#0049ae",
] as const;

const COLOR_WARNING = [
  "#fff6e2",
  "#ffebce",
  "#fbd59f",
  "#f7be6c",
  "#f4aa41",
  "#f39d26",
  "#f2930d",
  "#d88307",
  "#c07400",
  "#a76300",
  "#D66F00"
] as const;

const COLOR_POSITIVE = [
  "#e6feeb",
  "#d4f8da",
  "#abeeb6",
  "#7ee490",
  "#59dc6f",
  "#42d75b",
  "#31d44e",
  "#21bc3e",
  "#15a735",
  "#009029",
  "#049B22"
] as const;

const COLOR_NEGATIVE = [
  "#ffeaec",
  "#fed3d7",
  "#f5a6ac",
  "#ee757f",
  "#e84c59",
  "#e53340",
  "#e42131",
  "#cb1627",
  "#b60e21",
  "#a0001a",
] as const;

const COLOR_YELLOW = [
  "#fffae1",
  "#fff3cb",
  "#ffe69a",
  "#ffd964",
  "#ffcd38",
  "#ffc61c",
  "#ffc208",
  "#e3ab00",
  "#ca9800",
  "#af8200",
] as const;

const COLOR_INDIGO = [
  "#e9f3ff",
  "#d5e2fc",
  "#abc2f0",
  "#7ea1e5",
  "#5984dc",
  "#3c6fd6",
  "#3269d5",
  "#2358be",
  "#194eab",
  "#044398",
] as const;

const COLOR_PINK = [
  "#ffeafa",
  "#fed3ec",
  "#f6a5d5",
  "#f075bd",
  "#ea4ba8",
  "#e7319b",
  "#e72195",
  "#ce1381",
  "#b80873",
  "#a20064",
] as const;

const theme = createTheme({
  primaryColor: "primary",
  primaryShade: 7,

  colors: {
    orange: COLOR_ORANGE,
    blue: COLOR_BLUE,
    primary: COLOR_PRIMARY,
    neutral: COLOR_NEUTRAL,
    informative: COLOR_INFORMATIVE,

    red: COLOR_RED,
    warning: COLOR_WARNING,
    positive: COLOR_POSITIVE,
    negative: COLOR_NEGATIVE,
    yellow: COLOR_YELLOW,
    indigo: COLOR_INDIGO,
    pink: COLOR_PINK,

    // abyss_blue: COLOR_ABYSS_BLUE,
  },
  /** Put your mantine theme override here */
});

export default theme;
